// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__36JM-","content":"ManualTimeModal_content__1dVKy"};